import React, { useState } from 'react';
import { Box, Flex, Button } from "@chakra-ui/react";
import Select from "react-select";
import DateRangeFilter from "components/DateRangeFilter/DateRangeFilter";
import sharedSelectStyles from "components/Styles/reactSelectStyles";
const storeIdOptions = [];
const iterationIdOptions = [];
const stagingIdOptions = [];
const processFlagOptions = [];

const redBorderSelectStyles = {
  ...sharedSelectStyles,
  control: (provided, state) => ({
    ...sharedSelectStyles.control(provided, state),
    borderColor: "#E53E3E",
    boxShadow: state.isFocused
      ? "0 0 0 3px rgba(229, 62, 62, 0.6)"
      : "0 4px 6px rgba(0, 0, 0, 0.1)",
    "&:hover": {
      borderColor: "#C53030",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    },
  }),
};

const storeIdSelectStyles = {
  ...redBorderSelectStyles,
  control: (provided, state) => ({
    ...redBorderSelectStyles.control(provided, state),
    height: "auto",
    maxHeight: "80px",
    overflowY: "auto",
  }),
  valueContainer: (provided) => ({
    ...provided,
    maxHeight: "64px",
    overflowY: "auto",
    flexWrap: "wrap",
  }),
};

function ScorePipelineConfigurations(){
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedStoreIds, setSelectedStoreIds] = useState([]);
  const [selectedIterationId, setSelectedIterationId] = useState(null);
  const [selectedStagingId, setSelectedStagingId] = useState(null);
  const [selectedProcessFlag, setSelectedProcessFlag] = useState(null);

  const handleUpdate = () => {
  };

  return(
    <Box minH="100vh" bg="gray.50" pt={{ base: "10vh", md: "13vh" }}>
      <Flex justify="flex-end" px={6}>
        <DateRangeFilter
          fromDate={fromDate}
          toDate={toDate}
          onFromDateChange={setFromDate}
          onToDateChange={setToDate}
        />
      </Flex>

      <Flex
        align="center"
        gap={4}
        px={6}
        mt={6}
        flexWrap="wrap"
      >
        <Box minW="220px">
          <Select
            isMulti
            options={storeIdOptions}
            value={selectedStoreIds}
            onChange={(value) => setSelectedStoreIds(value || [])}
            placeholder="Store ID"
            closeMenuOnSelect={false}
            isClearable
            styles={storeIdSelectStyles}
          />
        </Box>

        <Box minW="220px">
          <Select
            options={processFlagOptions}
            value={selectedProcessFlag}
            onChange={(value) => setSelectedProcessFlag(value)}
            placeholder="Process Flag"
            isClearable
            styles={redBorderSelectStyles}
          />
        </Box>

        <Button colorScheme="red" onClick={handleUpdate}>
          Update
        </Button>
      </Flex>

      <Flex
        align="center"
        gap={4}
        px={6}
        mt={4}
        flexWrap="wrap"
      >
        <Box minW="220px">
          <Select
            options={iterationIdOptions}
            value={selectedIterationId}
            onChange={(value) => setSelectedIterationId(value)}
            placeholder="Iteration ID"
            isClearable
            styles={redBorderSelectStyles}
          />
        </Box>

        <Box minW="220px">
          <Select
            options={processFlagOptions}
            value={selectedProcessFlag}
            onChange={(value) => setSelectedProcessFlag(value)}
            placeholder="Process Flag"
            isClearable
            styles={redBorderSelectStyles}
          />
        </Box>

        <Button colorScheme="red" onClick={handleUpdate}>
          Update
        </Button>
      </Flex>

      <Flex
        align="center"
        gap={4}
        px={6}
        mt={4}
        flexWrap="wrap"
      >
        <Box minW="220px">
          <Select
            options={stagingIdOptions}
            value={selectedStagingId}
            onChange={(value) => setSelectedStagingId(value)}
            placeholder="Staging ID"
            isClearable
            styles={redBorderSelectStyles}
          />
        </Box>

        <Box minW="220px">
          <Select
            options={processFlagOptions}
            value={selectedProcessFlag}
            onChange={(value) => setSelectedProcessFlag(value)}
            placeholder="Process Flag"
            isClearable
            styles={redBorderSelectStyles}
          />
        </Box>

        <Button colorScheme="red" onClick={handleUpdate}>
          Update
        </Button>
      </Flex>
    </Box>
  )
}

export default ScorePipelineConfigurations;